import httpclient from"./httpclient";export default{info:{key:"java",title:"Java",extname:".java",default:"httpclient"},httpclient:httpclient};
//# sourceMappingURL=index.js.map